import React, { Component, Fragment } from 'react';
import { Input, Row, Col, Form, InputNumber, Button, Divider, Collapse, Select } from 'antd';
import { IndicatorSelector } from './IndicatorSelector';
import { IndicatorForm } from './IndicatorForm';
import { SignalForm } from './SignalForm';
import { Indicators } from './indicators';
const Panel = Collapse.Panel;
const FormItem = Form.Item;
const Option = Select.Option;

export class IndicatorGroup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            group: props.group,
            open: false
        };
    }

    handleIndicatorUpdate(id, config) {
        let group = { ...this.state.group };
        group.indicators[id] = config;
        this.setState({ group });
        this.props.onGroupUpdate(group);
    }

    handleSignalUpdate(id, config) {
        let group = { ...this.state.group };
        group.signals[id] = config;
        this.setState({ group });
        this.props.onGroupUpdate(group);
    }

    handleRemoveIndicator(id, config) {
        let group = { ...this.state.group };

        const indicator = group.indicators[id];
        group.indicators.splice(id, 1);

        for (let i = 0; i < group.signals.length; i++) {
            const signal = group.signals[i];

            if (signal.a.indexOf(indicator.id) === 0) group.signals.splice(i, 1);
            if (signal.b.indexOf(indicator.id) === 0) group.signals.splice(i, 1);
        }
        this.setState({ group });
        this.props.onGroupUpdate(group);
    }

    handleRemoveSignal(id, config) {
        let group = { ...this.state.group };
        group.signals.splice(id, 1);
        this.setState({ group });
        this.props.onGroupUpdate(group);
    }

    handleGroupChange(key, value) {
        let group = { ...this.state.group };
        group[key] = value;
        this.setState({ group });
        this.props.onGroupUpdate(group);
    }

    render() {
        const { group } = this.state;

        const signalIndicators = this.getIndicatorOutputs(group.indicators);

        console.log(signalIndicators);
        return (
            <Fragment>
                <Row gutter={24}>
                    <Col md={12}>
                        <FormItem label={'Group Name'}>
                            <Input
                                value={group.name}
                                onChange={e => this.handleGroupChange('name', e.target.value)}
                            />
                        </FormItem>
                    </Col>
                    <Col md={2}>
                        <FormItem label={'Consensus'}>
                            <InputNumber
                                value={group.concensus}
                                min={1}
                                onChange={this.handleGroupChange.bind(this, 'concensus')}
                            />
                        </FormItem>
                    </Col>
                    {this.props.signalPrice ? (
                        <Col md={4}>
                            <FormItem label={'Signal Price'}>
                                <Select
                                    style={{ width: '100%' }}
                                    value={group.signal_price || 'current_price'}
                                    onChange={value =>
                                        this.handleGroupChange('signal_price', value)
                                    }
                                >
                                    <Option value="current_price">Current Price</Option>
                                    {signalIndicators.map(output => {
                                        return (
                                            <Option key={output.value} value={output.value}>
                                                {output.title}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            </FormItem>
                        </Col>
                    ) : null}
                </Row>

                <Divider orientation={'left'}>Indicators</Divider>
                {!group.indicators.length ? (
                    <div style={{ padding: 10, textAlign: 'center' }}>No indicators</div>
                ) : (
                    <Fragment>
                        <Collapse>
                            {group.indicators.map((item, id) => {
                                const indicator = Indicators[item.indicator_id];
                                if (!indicator) {
                                    return (
                                        <Panel key={id} header={'Migration Error'}>
                                            Indicator not migrated: {item.indicator_id}
                                        </Panel>
                                    );
                                }
                                return (
                                    <Panel
                                        key={id}
                                        header={`#${item.id} ${indicator.name} ${item.period} `}
                                    >
                                        <IndicatorForm
                                            onChange={this.handleIndicatorUpdate.bind(this, id)}
                                            onRemove={this.handleRemoveIndicator.bind(this, id)}
                                            indicator={item}
                                            indicators={group.indicators}
                                        />
                                    </Panel>
                                );
                            })}
                        </Collapse>
                    </Fragment>
                )}
                <Button
                    style={{ marginTop: 5 }}
                    block
                    type="primary"
                    onClick={() => {
                        this.setState({ open: true });
                    }}
                >
                    Add Indicator
                </Button>

                <Divider orientation={'left'}>Signals</Divider>
                {!group.signals.length ? (
                    <div style={{ padding: 10, textAlign: 'center' }}>No signals defined</div>
                ) : (
                    <Fragment>
                        {group.signals.map((item, id) => {
                            return (
                                <SignalForm
                                    key={id}
                                    onChange={this.handleSignalUpdate.bind(this, id)}
                                    onRemove={this.handleRemoveSignal.bind(this, id)}
                                    signal={item}
                                    indicators={group.indicators}
                                />
                            );
                        })}
                    </Fragment>
                )}

                <Button
                    block
                    type={'primary'}
                    style={{ marginTop: 5 }}
                    onClick={() => {
                        let g = { ...this.state.group };

                        g.signals.push({
                            a: '',
                            a_label: '',
                            b_label: 'Threshold',
                            clause: 'eq',
                            b: 'threshold',
                            threshold: 0,
                            keep_signal: 0,
                            required: false
                        });

                        this.setState({ group: g });
                    }}
                >
                    Add Signal
                </Button>

                <IndicatorSelector
                    open={this.state.open}
                    onSelect={indicator => {
                        let g = { ...this.state.group };
                        const nextId = g.indicators.length
                            ? g.indicators[g.indicators.length - 1].id + 1
                            : 1;
                        g.indicators.push({
                            id: nextId,
                            indicator_id: indicator.indicator_id,
                            period: indicator.defaultPeriod || '30m',
                            ...(indicator.defaults || {})
                        });
                        this.setState({ group: g });
                    }}
                    onClose={() => this.setState({ open: false })}
                />

                <div style={{ padding: 10, textAlign: 'right' }}>
                    <Button type="primary" onClick={this.props.onClone.bind(this)}>
                        Clone
                    </Button>
                    &nbsp;&nbsp;
                    <Button type="danger" onClick={this.props.onRemoveGroup.bind(this)}>
                        Remove Group
                    </Button>
                </div>
            </Fragment>
        );
    }

    getTimeFrames(indicators) {
        const set = new Set(indicators.map(i => i.period || '30m'));
        return [...set];
    }

    getIndicatorOutputs(selectedIndicators) {
        let indicatorOutputs = [];

        const timeframes = this.getTimeFrames(selectedIndicators);
        timeframes.forEach(tf => {
            indicatorOutputs.push({
                title: `${tf} - Close`,
                value: `${tf}:close`
            });
            indicatorOutputs.push({
                title: `${tf} - Open`,
                value: `${tf}:open`
            });
            indicatorOutputs.push({
                title: `${tf} - High`,
                value: `${tf}:high`
            });
            indicatorOutputs.push({
                title: `${tf} - Low`,
                value: `${tf}:low`
            });
        });

        selectedIndicators.forEach(ind => {
            const schema = Indicators[ind.indicator_id];
            if (!schema) return;
            schema.outputs.forEach(output => {
                indicatorOutputs.push({
                    title: `#${ind.id} ${schema.name} ${ind.period} - ${output.label}`,
                    value: `${ind.id}:${output.name}`
                });
            });
        });
        return indicatorOutputs;
    }
}



// WEBPACK FOOTER //
// ./src/Account/Strategies/Shared/IndicatorManager/IndicatorGroup.js